import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

@engineComponent(ComponentTypes.DisplayObject)
export class ContainerElementExtended extends ContainerElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private dynamicX: number;

    private dynamicY: number;

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    constructor() {
        super();

        this.dynamicX = 0;
        this.dynamicY = 0;
    }

    public setDynamicValues(dynamicX: number, dynamicY: number): void {
        this.dynamicX = dynamicX;
        this.dynamicY = dynamicY;
    }

    //******************************************************************************************************************
    //  OVERRIDES
    //******************************************************************************************************************

    protected formatTweenValues(tween: string, values: Array<string>): Array<number> {
        for (let i: number = 0; i < values.length; i++) {
            if (values[i] == "dynamicX") {
                values[i] = this.dynamicX.toString();
            } else if (values[i] == "dynamicY") {
                values[i] = this.dynamicY.toString();
            }
        }

        return super.formatTweenValues(tween, values);
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return ContainerElement
     */
    clone(): ContainerElementExtended {
        let element: ContainerElementExtended = new ContainerElementExtended();

        element.style = this.style;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        element.name = this.name;

        element.childs = {};
        element.removeChildren();
        for (let key in this.childs) {
            element.childs[key] = this.childs[key].clone();
            element.addChild(element.childs[key]);
        }

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        }

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ContainerElementExtended.ts
 **/